import {
  TdChatProps,
  TdChatItemProps,
  TdChatListProps,
  TdChatActionsProps,
  TdChatInputProps,
  TdChatContentProps,
  TdChatSenderProps,
} from './type';
import { PropType } from 'vue';

export default {
  /** 操作 */
  actions: {
    type: Function as PropType<TdChatProps['actions']>,
  },
  /** 作者 */
  name: {
    type: [String, Function] as PropType<TdChatItemProps['name']>,
  },
  /** 头像 */
  avatar: {
    type: [String, Object, Function] as PropType<TdChatItemProps['avatar']>,
  },
  /** 内容 */
  content: {
    type: [String] as PropType<TdChatItemProps['content']>,
    default: '',
  },
  /** 时间 */
  datetime: {
    type: [String, Function] as PropType<TdChatItemProps['datetime']>,
  },
  /** 角色 */
  role: {
    type: [String, Function] as PropType<TdChatItemProps['role']>,
    default: '',
    validator(val: string) {
      if (!val) return true;
      return ['assistant', 'user', 'error', 'model-change', 'system'].includes(val);
    },
  },
  /** 点赞选中 */
  isGood: {
    type: Boolean as PropType<TdChatActionsProps['isGood']>,
    default: false,
  },
  /** 差评选中 */
  isBad: {
    type: Boolean as PropType<TdChatActionsProps['isBad']>,
    default: false,
  },
  /** 对齐 */
  layout: {
    type: [String] as PropType<TdChatProps['layout']>,
    default: 'both',
    validator(val: string) {
      if (!val) return true;
      return ['single', 'both'].includes(val);
    },
  },
  isStreamLoad: {
    type: Boolean as PropType<TdChatProps['isStreamLoad']>,
    default: false,
  },
  /** 清空历史按钮，值为 true 显示默认操作按钮，值为 false 不显示任何内容，值类型为 Function 表示自定义 */
  clearHistory: {
    type: [Boolean] as PropType<TdChatProps['clearHistory']>,
    default: true as TdChatProps['clearHistory'],
  },
  /** 倒序渲染,默认倒序渲染 */
  reverse: {
    type: Boolean as PropType<TdChatProps['reverse']>,
    default: true,
  },
  /** 流式消息加载中 */
  textLoading: {
    type: [Boolean, Function] as PropType<TdChatItemProps['textLoading']>,
    default: false,
  },
  /** 数据 */
  data: {
    type: Array as PropType<TdChatListProps['data']>,
  },
  variant: {
    type: String as PropType<TdChatItemProps['variant']>,
    default: 'text',
    validator(val: string) {
      if (!val) return true;
      return ['text', 'base', 'outline'].includes(val);
    },
  },
  /* 动画加载 skeleton：骨架屏 gradient：渐变加载动画一个点 moving：三个点 */
  animation: {
    type: String as PropType<TdChatItemProps['animation']>,
    default: 'skeleton',
    validator(val: string) {
      if (!val) return true;
      return ['skeleton', 'moving', 'gradient'].includes(val);
    },
  },
  /** 点击时触发 */
  onClear: Function as PropType<TdChatProps['onClear']>,
  operationBtn: {
    type: Array as PropType<operationBtnType[]>,
    default: ['replay', 'copy', 'good', 'bad'],
  },
  onOperation: Function as PropType<TdChatActionsProps['onOperation']>,
  disabled: Boolean as PropType<TdChatActionsProps['disabled']>,
  onSend: Function as PropType<TdChatInputProps['onSend']>,
  onStop: Function as PropType<TdChatInputProps['onStop']>,
  onChange: Function as PropType<TdChatInputProps['onChange']>,
  onScroll: Function as PropType<TdChatListProps['onScroll']>,
  onFocus: Function as PropType<TdChatInputProps['onFocus']>,
  onBlur: Function as PropType<TdChatInputProps['onBlur']>,
  /** 高度自动撑开。 autosize = true 表示组件高度自动撑开，同时，依旧允许手动拖高度。如果设置了 autosize.maxRows 或者 autosize.minRows 则不允许手动调整高度 */
  autosize: {
    type: [Boolean, Object] as PropType<TdChatInputProps['autosize']>,
    default: { minRows: 1, maxRows: 5 },
  },
  reasoning: {
    type: [Boolean, Object, String] as PropType<TdChatItemProps['reasoning']>,
    default: false as TdChatItemProps['reasoning'],
  },
  /** 透传 Textarea 组件全部特性 */
  textareaProps: {
    type: Object as PropType<TdChatSenderProps['textareaProps']>,
  },
};
export type operationBtnType = 'replay' | 'copy' | 'good' | 'bad';
